function FaqSection() {
  const { SectionEyebrow } = window.AppComponents;
  const { faqs } = window.AppData.siteContent;

  return (
    <section id="faq" className="py-9">
      <div className="mb-6 max-w-3xl">
        <SectionEyebrow>FAQs</SectionEyebrow>
        <h2 className="mt-4 font-display text-4xl font-bold tracking-[-0.05em] text-ink md:text-5xl">
          Questions people usually ask before buying cover
        </h2>
      </div>

      <div className="grid gap-4">
        {faqs.map((faq) => (
          <article
            key={faq.question}
            className="rounded-[26px] border border-white/80 bg-white/80 p-6 shadow-glow backdrop-blur-xl"
          >
            <h3 className="text-xl font-bold">{faq.question}</h3>
            <p className="mt-3 leading-7 text-slate-500">{faq.answer}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

window.AppSections = window.AppSections || {};
window.AppSections.FaqSection = FaqSection;
